// Apenas correlação e chave idempotente, separadas por empresa/usuário.
// Nunca armazenar formulário, snapshot, CPF/CNPJ, XML ou URL assinada.
export function createAttemptStore(scope, storage = sessionStorage) {
  const key = (kind, id) => `nfse:attempt:${scope.empresaId}:${scope.userId}:${kind}:${id}`
  return {
    read(kind, id) { return storage.getItem(key(kind, id)) },
    write(kind, id, value) { storage.setItem(key(kind, id), value) },
    remove(kind, id) { storage.removeItem(key(kind, id)) },
  }
}
